import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppProvider, Frame } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import App from './App';
import '@shopify/polaris/build/esm/styles.css';
import '@reach/settings-workspace/styles.css';
import './index.css';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({ dsn: import.meta.env.VITE_SENTRY_DSN, environment: import.meta.env.MODE });
}

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1 } } });
const DASHBOARD_THEME_STORAGE_KEY = 'reach_dashboard_theme';
const LOCKED_DASHBOARD_THEME = 'ocean';
document.documentElement.setAttribute('data-theme', LOCKED_DASHBOARD_THEME);
localStorage.setItem(DASHBOARD_THEME_STORAGE_KEY, LOCKED_DASHBOARD_THEME);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProvider i18n={enTranslations}>
      <Frame>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
              <App />
            </Sentry.ErrorBoundary>
          </BrowserRouter>
        </QueryClientProvider>
      </Frame>
    </AppProvider>
  </React.StrictMode>
);
